<p-dialog [(visible)]="visible" [modal]="true"
    [style]="{ width: '90vw', maxWidth: '800px' }"
    (onHide)="handleClose()" [draggable]="false" [resizable]="false">

    <!-- HEADER -->
    <div class="flex justify-center items-center dialog-header relative">
        {{ formAction }} Addon Top-up
        <button (click)="handleClose()" class="absolute right-3 top-3 p-2 outline-none">
            <i class="pi pi-times text-xl"></i>
        </button>
    </div>

    <!-- BODY -->
    <div class="dialog-content">
        <form [formGroup]="assignForm" (ngSubmit)="submitForm()">

            <div class="grid formgrid p-fluid gap-4">

                <!-- TITLE -->
                <div class="col-12">
                    <h3 class="text-xl font-semibold">Addon Top-up Details</h3>
                    <p class="text-gray-500 text-sm">Add extra resources to client subscription</p>
                </div>

                <!-- CLIENT -->
                <div class="col-12 md:col-6">
                    <label>Select Client *</label>
                    <p-dropdown
                        formControlName="client_id"
                        [options]="clients"
                        optionLabel="client_name"
                        optionValue="client_id"
                        [filter]="true"
                        filterBy="client_name"
                        placeholder="Select client"
                        (onChange)="onClientSelect($event)"
                        class="w-full">
                    </p-dropdown>
                </div>

                <!-- PACKAGE SUBSCRIPTION -->
                <div class="col-12 md:col-6">
                    <label>Select Package Subscription *</label>
                    <p-dropdown
                        formControlName="package_subscription_id"
                        [options]="packageSubscriptions"
                        optionLabel="package_name"
                        optionValue="package_subscription_id"
                        [filter]="true"
                        placeholder="Select package subscription"
                        [disabled]="!assignForm.get('client_id')?.value"
                        class="w-full">
                        
                        <ng-template let-subscription pTemplate="item">
                            <div class="flex justify-between items-center">
                                <div>
                                    <div class="font-semibold">{{ subscription.package_name }}</div>
                                    <div class="text-xs text-gray-500">{{ subscription.billing_cycle }} - {{ subscription.status }}</div>
                                </div>
                                <div class="text-sm text-blue-600">₹{{ subscription.price }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>

                <!-- ADDON -->
                <div class="col-12 md:col-6">
                    <label>Select Add-on *</label>
                    <p-dropdown
                        formControlName="addon_id"
                        [options]="addons"
                        optionLabel="addon_name"
                        optionValue="id"
                        [filter]="true"
                        placeholder="Select addon"
                        (onChange)="onAddonSelect($event)"
                        class="w-full">
                    </p-dropdown>
                </div>

                <!-- QUANTITY -->
                <div class="col-12 md:col-4">
                    <label>Quantity *</label>
                    <p-inputNumber formControlName="quantity" min="1" class="w-full"></p-inputNumber>
                </div>

                <!-- STATUS -->
                <div class="col-12 md:col-4">
                    <label>Status *</label>
                    <p-dropdown
                        formControlName="status"
                        [options]="statusOptions"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full">
                    </p-dropdown>
                </div>

                <!-- PAYMENT STATUS -->
                <div class="col-12 md:col-4">
                    <label>Payment Status *</label>
                    <p-dropdown
                        formControlName="payment_status"
                        [options]="paymentStatus"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full">
                    </p-dropdown>
                </div>

                <!-- BILLING TYPE (HIDDEN - FIXED BY DEFAULT) -->
                <input type="hidden" formControlName="billing_type" value="Fixed">

                <!-- NOTES -->
                <div class="col-12">
                    <label>Notes</label>
                    <textarea
                        pInputTextarea
                        formControlName="notes"
                        rows="3"
                        placeholder="Optional notes..."
                        class="w-full">
                    </textarea>
                </div>

                <!-- ADDON PREVIEW -->
                <div class="col-12" *ngIf="selectedAddon">
                    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4">
                        
                        <h4 class="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                            <i class="pi pi-shopping-cart text-blue-600"></i>
                            Order Summary
                        </h4>

                        <!-- Addon Name & Price -->
                        <div class="bg-white rounded-lg p-4 mb-3 shadow-sm">
                            <div class="flex justify-between items-start mb-2">
                                <div>
                                    <h5 class="text-xl font-bold text-gray-900">{{ selectedAddon.addon_name || selectedAddon.name }}</h5>
                                    <p class="text-sm text-gray-500" *ngIf="selectedAddon.description">
                                        {{ selectedAddon.description }}
                                    </p>
                                </div>
                                <div class="text-right">
                                    <p class="text-sm text-gray-500">Unit Price</p>
                                    <p class="text-lg font-semibold text-blue-600">₹{{ selectedAddon.price }}</p>
                                </div>
                            </div>

                            <!-- Quantity Calculation -->
                            <div class="flex justify-between items-center pt-3 border-t border-gray-200">
                                <span class="text-gray-600">
                                    ₹{{ selectedAddon.price }} × {{ assignForm.get('quantity')?.value }} unit(s)
                                </span>
                                <span class="text-2xl font-bold text-green-600">
                                    ₹{{ getTotalPrice() }}
                                </span>
                            </div>
                        </div>

                        <!-- Features List -->
                        <div class="bg-white rounded-lg p-4 shadow-sm" *ngIf="selectedAddon.feature && getFormattedFeatures(selectedAddon.feature).length > 0">
                            <h6 class="font-semibold text-gray-800 mb-2 flex items-center gap-2">
                                <i class="pi pi-check-circle text-green-500"></i>
                                Included Features
                            </h6>
                            <ul class="space-y-2">
                                <li *ngFor="let f of getFormattedFeatures(selectedAddon.feature)" 
                                    class="flex items-center gap-2 text-sm text-gray-700">
                                    <i class="pi pi-angle-right text-blue-500"></i>
                                    <span class="font-medium">{{ f.label }}:</span>
                                    <span class="text-gray-900 font-semibold">{{ f.value }}</span>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

            </div>

            <!-- FOOTER BUTTONS -->
            <div class="flex justify-end gap-3 mt-4">
                <p-button label="Cancel" text (onClick)="handleClose()"></p-button>
                <p-button label="Save Addon Top-up"
                    icon="pi pi-check"
                    type="submit"
                    [loading]="isLoading"
                    [disabled]="assignForm.invalid || isLoading">
                </p-button>
            </div>

        </form>
    </div>

</p-dialog>
